<template>
  <div :class="['section-summary-container', blockWidthClass]">
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useEditorMetaDataStore } from '../../../store/editor-meta-data.store';

const { blockWidthClass } = storeToRefs(useEditorMetaDataStore());
</script>
<style lang="scss" scoped>
.section-summary-container {
  width: 383px;
  display: flex;
  flex-direction: column;
  background: var(--gray-96);
  border-radius: var(--radius-medium);
  padding: var(--spacing-75);
  gap: var(--spacing-100);

  &.xsmall,
  &.xxsmall {
    width: 100%;
  }
}
</style>
